import { type App, EmployeePayrollDataDTO, ErrorCode } from "@pentacode/core";

export const payrollDataKey = ["employee-payroll-data"] as const;

export function payrollDataQuery(app: App, employeeId: number) {
    return {
        queryKey: [...payrollDataKey, employeeId] as const,
        queryFn: async () => {
            try {
                return await app.api.getEmployeePayrollData({ employeeId });
            } catch (error) {
                // No payroll data exists yet: the form starts empty.
                if ((error as { code?: ErrorCode })?.code === ErrorCode.NOT_FOUND) {
                    return new EmployeePayrollDataDTO({ employeeId, mainJob: false });
                }
                throw error;
            }
        },
    };
}
